
import { DateFormatter } from '@/utilities/date-formatter';
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        value: {
            type: Number,
            required: true,
        }
    },

    setup()
    {
        function formatUnixTimestamp(date: number): string
        {
            return new DateFormatter().isoDateTime(new Date(date * 1000));
        }

        return { formatUnixTimestamp };
    },
})
